"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LinkVariants = exports.LinkVariantPropType = exports.LinkTargetPropType = exports.LinkTarget = exports.LinkRelPropType = exports.LinkRel = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var LinkTarget = exports.LinkTarget = Object.freeze({
  BLANK: '_blank',
  PARENT: '_parent',
  SELF: '_self',
  TOP: '_top'
});
var LinkVariants = exports.LinkVariants = Object.freeze({
  DEFAULT: 'default',
  INVERSE: 'inverse'
});
var LinkVariantPropType = exports.LinkVariantPropType = _propTypes["default"].oneOf(Object.values(LinkVariants));
var LinkRel = exports.LinkRel = Object.freeze({
  ALTERNATE: 'alternate',
  AUTHOR: 'author',
  BOOKMARK: 'bookmark',
  EXTERNAL: 'external',
  HELP: 'help',
  LICENSE: 'license',
  NEXT: 'next',
  NOFOLLOW: 'nofollow',
  NOREFERRER: 'noreferrer',
  NOOPENER: 'noopener',
  PREV: 'prev',
  SEARCH: 'search',
  TAG: 'tag'
});
var LinkTargetPropType = exports.LinkTargetPropType = _propTypes["default"].oneOf(Object.values(LinkTarget));
var LinkRelPropType = exports.LinkRelPropType = _propTypes["default"].oneOf(Object.values(LinkRel));
var _default = exports["default"] = LinkTargetPropType;